@if(filledInfo && sectionData){
<div nz-row tabindex="0">
  @if(isAttrAvailable('trackingNumber')){
    <div nz-col  nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'trackingNumber']">
      <div nz-row>
  
        <div nz-col nzSpan="12"  [nzXs]="9" ngClass="font-weight-600 pt-2 ">
          {{ getAttributes("trackingNumber").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
          <span>
            {{ filledInfo?.trackingNumber ? filledInfo?.trackingNumber : '-' }}
          </span>
          <span *ngIf="!filledInfo?.trackingNumber" class="sr-only">Blank</span>
        </div>
      </div>
    </div>
    }
    @if(isAttrAvailable('id')){
      <div nz-col  nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'id']">
        <div nz-row>
    
          <div nz-col nzSpan="12"  [nzXs]="9" ngClass="font-weight-600 pt-2 ">
            {{ getAttributes("id").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
            <span>
              {{ id ? id : '-' }}
            </span>
            <span *ngIf="!id" class="sr-only">Blank</span>
          </div>
        </div>
      </div>
      }
      @if(isAttrAvailable('applicationStatusLkp')){
        <div nz-col  nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'applicationStatusLkp']">
          <div nz-row>
            <div nz-col nzSpan="12"  [nzXs]="9" ngClass="font-weight-600 pt-2 ">
              {{ getAttributes("applicationStatusLkp").label }}
            </div>
            <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
              <span>
                {{ getApplicationStatusLabel() }}
              </span>
              <span *ngIf="!filledInfo?.applicationStatus" class="sr-only">Blank</span>
            </div>
          </div>
        </div>
        }
      @if(isAttrAvailable('participantProgramCode')){
        <div nz-col  nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'participantProgramCode']">
          <div nz-row>
            <div nz-col nzSpan="12"  [nzXs]="9" ngClass="font-weight-600 pt-2 ">
              {{ getAttributes("participantProgramCode").label }}
            </div>
            <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
              <span>
                {{ programCode ? programCode : '-' }}
              </span>
              <span *ngIf="!programCode" class="sr-only">Blank</span>
            </div>
          </div>
        </div>
        }
  @if(isAttrAvailable('decisionComments')){

  <div nz-col  nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'decisionComments']">
    <div nz-row>
      <div nz-col nzSpan="12"  [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("decisionComments").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        <span>
          {{ filledInfo?.decisionComments ? filledInfo?.decisionComments : '-'}}
        </span>
        <span *ngIf="!filledInfo?.decisionComments" class="sr-only">Blank</span>
      </div>
    </div>
  </div>
  } @if(isAttrAvailable('applicationAssignedToUser') && showAssignedTo){
  <div nz-col  nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'applicationAssignedToUser']">
    <div nz-row>

      <div nz-col nzSpan="12"  [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("applicationAssignedToUser").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        <span>
          {{ filledInfo?.applicationAssignedToUser ? filledInfo?.applicationAssignedToUser : '-' }}
        </span>
        <span *ngIf="!filledInfo?.applicationAssignedToUser" class="sr-only">Blank</span>
      </div>
    </div>
  </div>
  } 
    @if(isAttrAvailable('applicationStage')){
      <div nz-col  nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'applicationStage']">
        <div nz-row>
    
          <div nz-col nzSpan="12"  [nzXs]="9" ngClass="font-weight-600 pt-2 ">
            {{ getAttributes("applicationStage").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
            <span>
              {{ filledInfo?.applicationStage ? getLookupValue(getLookup('Lead_Application_Stage'),filledInfo?.applicationStage) : '-' }}
            </span>
            <span *ngIf="!filledInfo?.applicationStage" class="sr-only">Blank</span>
          </div>
        </div>
      </div>
      }
    @if(isAttrAvailable('finalApplicantDisposition')){
      <div nz-col  nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'finalApplicantDisposition']">
        <div nz-row>
    
          <div nz-col nzSpan="12"  [nzXs]="9" ngClass="font-weight-600 pt-2 ">
            {{ getAttributes("finalApplicantDisposition").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
            <span>
              {{ filledInfo?.finalApplicantDisposition ? filledInfo?.finalApplicantDisposition : '-' }}
            </span>
            <span *ngIf="!filledInfo?.finalApplicantDisposition" class="sr-only">Blank</span>
          </div>
        </div>
      </div>
      }
      @if(isAttrAvailable('applicationSubmissionDate')){
  <div nz-col  nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'applicationSubmissionDate']">
    <div nz-row>

      <div nz-col nzSpan="12"  [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("applicationSubmissionDate").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        <span>
          {{
            (filledInfo?.applicationSubmissionDate)
            |
            date:'MM/dd/yyyy'
            }}
        </span>
        <span *ngIf="!filledInfo?.applicationSubmissionDate" class="sr-only">Blank</span>
      </div>
    </div>
  </div>

  }@if(isAttrAvailable('applicationSource')){
  <div nz-col  nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'applicationSource']">
    <div nz-row>

      <div nz-col nzSpan="12"  [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("applicationSource").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        <span>
          {{ filledInfo?.applicationSource }}
        </span>
        <span *ngIf="!filledInfo?.applicationSource" class="sr-only">Blank</span>
      </div>
    </div>
  </div>
  }@if(isAttrAvailable('createdBy') && isCreatedByVisible()){
  <div nz-col  nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'createdBy']">
    <div nz-row>

      <div nz-col nzSpan="12"  [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("createdBy").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        <span>
          {{ getCreatedByDisplayValue() || '-' }}
        </span>
        <span *ngIf="!getCreatedByDisplayValue()" class="sr-only">Blank</span>
      </div>
    </div>
  </div>
  }
  <!-- @if(isAttrAvailable('draAckDate') && isPA){
    <div nz-col  nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'draAckDate']">
      <div nz-row>
  
        <div nz-col nzSpan="12"  [nzXs]="9" ngClass="font-weight-600 pt-2 ">
          {{ getAttributes("draAckDate").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
          <span>
            {{ filledInfo?.draAckDate ? (filledInfo?.draAckDate | date:'MM/dd/yyyy') : '-' }}
          </span>
          <span *ngIf="!filledInfo?.draAckDate" class="sr-only">Blank</span>
        </div>
      </div>
    </div>
  }  -->
  @if(isAttrAvailable('providerType')){
    <div nz-col  nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'providerType']">
      <div nz-row>
  
        <div nz-col nzSpan="12"  [nzXs]="9" ngClass="font-weight-600 pt-2 ">
          {{ getAttributes("providerType").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
          <span>
            {{ providerType }}
          </span>
          <span *ngIf="!providerType" class="sr-only">Blank</span>
        </div>
      </div>
    </div>
    }
</div>
}@else{
<nz-row>
  <p>No Data found</p>
</nz-row>
}